export default __webpack_public_path__ + "static/integrity-cdf7383e67742ec2da4957a75f2a26eb.svg";